import { useTranslation } from 'react-i18next';

import { OppvarmingFormData } from '../../../types';

export const useElektrisitetValidation = () => {
  const { t } = useTranslation();
  const validateElektrisitetSelection = (_: boolean, { elektrisk }: OppvarmingFormData) => {
    // At least one sub-option must be selected
    if (
      !elektrisk?.value?.panelovn.selected &&
      !elektrisk?.value?.gulvvarme.selected &&
      !elektrisk?.value?.kjel.selected &&
      !elektrisk?.value?.luftvarme.selected &&
      !elektrisk?.value?.takvarme.selected &&
      !elektrisk?.value?.varmtvannsbereder.selected
    ) {
      return t('form.oppvarming.elektrisitet.error');
    }
    return true;
  };

  return {
    validateElektrisitetSelection
  };
};
